var map = {
	"./admin.svg": 6263,
	"./bronze.svg": 8974,
	"./gold.svg": 9340,
	"./mod.svg": 3950,
	"./partner.svg": 4392,
	"./platinum.svg": 8846,
	"./silver.svg": 2601,
	"./titanium.svg": 231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4668;